document.addEventListener('DOMContentLoaded', () => {
	const MAX_ROWS = 6;
	// ── Limit hero tags to 3 rows (2 on mobile) ─────────────────────────────
	const tagsContainer = document.querySelector('.baza-znan-archive__hero-tags');
	if (tagsContainer) {
		const TAGS_MAX_ROWS = window.innerWidth <= 921 ? 2 : 3;
		const chips = Array.from(tagsContainer.children);
		const rows = [];
		let lastTop = null;
		chips.forEach(chip => {
			const top = chip.offsetTop;
			if (top !== lastTop) { rows.push([]); lastTop = top; }
			rows[rows.length - 1].push(chip);
		});
		rows.slice(TAGS_MAX_ROWS).forEach(row => row.forEach(chip => chip.classList.add('is-over-limit')));
	}

	// ── Init collapse + load-more on a results container ─────────────────────
	function bzInitResults(container) {
		container.querySelectorAll('.js-bz-toggle').forEach(btn => {
			btn.addEventListener('click', () => {
				const block    = btn.closest('.baza-znan-archive__cat-block');
				const list     = block.querySelector('.js-bz-cat-list');
				const label    = btn.querySelector('span');
				const expanded = btn.getAttribute('aria-expanded') === 'true';

				btn.setAttribute('aria-expanded', String(!expanded));
				list.classList.toggle('is-hidden', expanded);
				block.classList.toggle('is-collapsed', expanded);
				if (label) label.textContent = expanded ? 'Розгорнути' : 'Приховати';
			});
		});

		container.querySelectorAll('.js-bz-cat-list').forEach(list => {
			const items = Array.from(list.children);
			if (items.length === 0) return;

			// Групуємо елементи по рядках: однаковий offsetTop = один рядок
			const rows = [];
			let lastTop = null;
			items.forEach(item => {
				const top = item.offsetTop;
				if (top !== lastTop) { rows.push([]); lastTop = top; }
				rows[rows.length - 1].push(item);
			});

			if (rows.length <= MAX_ROWS) return;

			// Ховаємо елементи після 6-го рядка
			rows.slice(MAX_ROWS).forEach(row => row.forEach(item => { item.classList.add('is-over-limit'); }));

			const loadBtn = list.nextElementSibling;
			if (!loadBtn || !loadBtn.classList.contains('js-bz-load-more')) return;

			loadBtn.classList.add('is-visible');
			loadBtn.addEventListener('click', () => {
				items.forEach(item => { item.classList.remove('is-over-limit'); });
				loadBtn.classList.remove('is-visible');
			}, { once: true });
		});
	}

	// ── Scroll window to an element by id ────────────────────────────────────
	function bzScrollTo(id) {
		const el = document.getElementById(id);
		if (!el) return;
		const header = document.querySelector('.header-new');
		const offset = header ? header.offsetHeight + 16 : 0;
		const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
		window.scrollTo({ top, behavior: 'smooth' });
	}

	function bzUpdateUrl(params) {
		const url = new URL(window.location.href);

		if (params.bz_search) {
			url.searchParams.set('bz_search', params.bz_search);
		} else {
			url.searchParams.delete('bz_search');
		}

		if (params.bz_cat) {
			url.searchParams.set('bz_cat', params.bz_cat);
		} else {
			url.searchParams.delete('bz_cat');
		}

		if (params.bz_class) {
			url.searchParams.set('bz_class', params.bz_class);
		} else {
			url.searchParams.delete('bz_class');
		}

		url.hash = 'baza-znan-content';
		window.history.replaceState({}, '', url.toString());
	}
	function bzSyncSearchInputs(value) {
		document.querySelectorAll(
			'.baza-znan-archive__hero-search input[name="bz_search"],' +
			'.baza-znan-archive__filters input[name="bz_search"],' +
			'.bz-mpanel-search-input'
		).forEach(input => { input.value = value; });
	}

	// ── AJAX search ───────────────────────────────────────────────────────────
	function bzDoSearch(params) {
		const resultsEl = document.getElementById('bz-results');
		if (!resultsEl) return;

		const ajaxUrl = (window.bzSearchData && window.bzSearchData.ajaxUrl) || '/wp-admin/admin-ajax.php';
		const nonce   = (window.bzSearchData && window.bzSearchData.nonce)   || '';

		resultsEl.style.opacity = '0.5';
		resultsEl.style.pointerEvents = 'none';

		const body = new URLSearchParams({
			action:    'pifagor_bz_search',
			nonce,
			bz_search: params.bz_search || '',
			bz_cat:    params.bz_cat    || '',
			bz_class:  params.bz_class  || '',
		});

		fetch(ajaxUrl, {
			method:      'POST',
			headers:     { 'Content-Type': 'application/x-www-form-urlencoded' },
			body:        body.toString(),
			credentials: 'same-origin',
		})
		.then(r => r.json())
		.then(res => {
			if (!res.success) return;
			resultsEl.innerHTML = res.data.html;
			requestAnimationFrame(() => bzInitResults(resultsEl));

			bzSyncSearchInputs(params.bz_search || '');
		})
		.catch(err => console.error('[bz-search] AJAX error:', err))
		.finally(() => {
			resultsEl.style.opacity = '';
			resultsEl.style.pointerEvents = '';
		});
	}

	// ── Banner search intercept ───────────────────────────────────────────────
	const bannerForm = document.querySelector('.baza-znan-archive__hero-search');
	if (bannerForm) {
		bannerForm.addEventListener('submit', e => {
			e.preventDefault();
			const search = (bannerForm.querySelector('input[name="bz_search"]')?.value || '').trim();
			bzUpdateUrl({ bz_search: search });
			bzScrollTo('baza-znan-content');
			bzDoSearch({ bz_search: search });
		});
	}

	// ── Init results on page load ─────────────────────────────────────────────
	const resultsEl = document.getElementById('bz-results');
	if (resultsEl) bzInitResults(resultsEl);

	// ── Auto-scroll when page loads with filter params ────────────────────────
	const urlParams = new URLSearchParams(window.location.search);
	if (window.location.hash === '#baza-znan-content' || urlParams.get('bz_search') || urlParams.get('bz_cat') || urlParams.get('bz_class')) {
		window.requestAnimationFrame(() => bzScrollTo('baza-znan-content'));
	}

	// ── Filter form AJAX intercept ────────────────────────────────────────────
	const filterForm = document.querySelector('.baza-znan-archive__filters');
	if (filterForm) {
		filterForm.addEventListener('submit', e => {
			e.preventDefault();
			const search = (filterForm.querySelector('input[name="bz_search"]')?.value || '').trim();
			const cat    = filterForm.querySelector('select[name="bz_cat"]')?.value || '';
			const cls    = filterForm.querySelector('select[name="bz_class"]')?.value || '';
			bzUpdateUrl({ bz_search: search, bz_cat: cat, bz_class: cls });
			bzScrollTo('baza-znan-content');
			bzDoSearch({ bz_search: search, bz_cat: cat, bz_class: cls });
		});
	}

	// ── Sticky filter bar (desktop only) ────────────────────────────────────
	if (filterForm && window.innerWidth > 920) {
		const stickyHeader = document.querySelector('.header-new');
		const stickyFooter = document.querySelector('.footer') || document.querySelector('footer');

		const filterPlaceholder = document.createElement('div');
		filterPlaceholder.style.display = 'none';
		filterForm.parentNode.insertBefore(filterPlaceholder, filterForm);

		let naturalBottom = null;

		function updateStickyFilter() {
			if (naturalBottom === null) {
				if (filterForm.classList.contains('is-sticky')) return;
				const rect = filterForm.getBoundingClientRect();
				naturalBottom = rect.bottom + window.scrollY;
			}

			const headerH      = stickyHeader ? stickyHeader.offsetHeight : 0;
			const inViewBottom = naturalBottom - window.scrollY;
			const shouldStick  = inViewBottom < headerH;

			if (shouldStick) {
				if (!filterForm.classList.contains('is-sticky')) {
					filterPlaceholder.style.height       = filterForm.offsetHeight + 'px';
					filterPlaceholder.style.marginBottom = '32px';
					filterPlaceholder.style.display      = 'block';
					filterForm.classList.add('is-sticky');
				}

				const atFooter = stickyFooter
					? stickyFooter.getBoundingClientRect().top <= window.innerHeight - 32
					: false;
				filterForm.classList.toggle('is-sticky-hidden', atFooter);
			} else {
				if (filterForm.classList.contains('is-sticky')) {
					filterForm.classList.remove('is-sticky', 'is-sticky-hidden');
					filterPlaceholder.style.display = 'none';
				}
			}
		}

		updateStickyFilter();
		window.addEventListener('scroll', updateStickyFilter, { passive: true });
		window.addEventListener('resize', () => { naturalBottom = null; updateStickyFilter(); }, { passive: true });
	}

	// ── Section-scoped filter interdependencies ───────────────────────────────
	const section = document.querySelector('.baza-znan-archive__questions');
	if (!section) return;

	const dataEl = document.getElementById('bz-content-data');
	const data   = dataEl ? JSON.parse(dataEl.textContent) : {};
	const subjectClassMap = data.subjectClassMap || {};
	const classSubjectMap = data.classSubjectMap || {};

	const subjectSelect = section.querySelector('[data-bz-subject]');
	const classSelect   = section.querySelector('[data-bz-class]');

	// Sync custom select.js dropdown items to match native <option> disabled state
	function syncCustomSelectOptions(nativeSelect) {
		const wrapper = nativeSelect.closest('.select');
		if (!wrapper) return;

		Array.from(nativeSelect.options).forEach(opt => {
			if (!opt.value) return;
			const customOpt = wrapper.querySelector(`.select__option[data-value="${opt.value}"]`);
			if (!customOpt) return;
			if (opt.disabled) {
				customOpt.hidden = true;
			} else if (!opt.selected) {
				customOpt.hidden = false;
			}
		});

		if (!nativeSelect.value) {
			const titleContent = wrapper.querySelector('.select__content');
			if (titleContent) titleContent.textContent = nativeSelect.dataset.placeholder || '';
			wrapper.classList.remove('_select-active', 'has-value');
		}
	}

	// Programmatically set a custom select value without triggering selectCallback
	function setCustomSelectValue(nativeSelect, value) {
		const wrapper = nativeSelect.closest('.select');
		nativeSelect.value = value;
		if (!wrapper) return;

		wrapper.querySelectorAll('.select__option').forEach(customOpt => {
			const nativeOpt = nativeSelect.querySelector(`option[value="${customOpt.dataset.value}"]`);
			if (!nativeOpt || nativeOpt.disabled) {
				customOpt.hidden = true;
			} else {
				customOpt.hidden = (customOpt.dataset.value === value);
			}
		});

		const titleContent = wrapper.querySelector('.select__content');
		if (titleContent) {
			if (value) {
				const selectedOpt = nativeSelect.querySelector(`option[value="${value}"]`);
				titleContent.textContent = selectedOpt ? selectedOpt.textContent.trim() : '';
				wrapper.classList.add('_select-active', 'has-value');
			} else {
				titleContent.textContent = nativeSelect.dataset.placeholder || '';
				wrapper.classList.remove('_select-active', 'has-value');
			}
		}
	}

	function applySubjectToClasses(subjectId) {
		if (!classSelect) return;
		const available = subjectId && subjectClassMap[subjectId]
			? subjectClassMap[subjectId].map(String)
			: [];

		classSelect.querySelectorAll('option').forEach(opt => {
			if (!opt.value || opt.value === '0') return; // skip placeholder and Усі
			const ok = available.length === 0 || available.includes(opt.value);
			opt.disabled = !ok;
			if (!ok && opt.selected) { opt.selected = false; }
		});
		syncCustomSelectOptions(classSelect);
	}

	function applyClassToSubjects(classId) {
		if (!subjectSelect) return;
		const available = classId && classSubjectMap[classId]
			? classSubjectMap[classId].map(String)
			: [];

		subjectSelect.querySelectorAll('option').forEach(opt => {
			if (!opt.value || opt.value === '0') return; // skip placeholder and Усі
			const ok = available.length === 0 || available.includes(opt.value);
			opt.disabled = !ok;
			if (!ok && opt.selected) { opt.selected = false; }
		});
		syncCustomSelectOptions(subjectSelect);
	}

	function applyClassToSidebar(classId) {
		document.querySelectorAll('.baza-znan-archive__nav-group a[href]').forEach(a => {
			const url   = new URL(a.href, location.origin);
			const catId = url.searchParams.get('bz_cat');
			if (!catId) return;
			const available = classId && classSubjectMap[classId]
				? classSubjectMap[classId].map(String)
				: [];
			const ok = available.length === 0 || available.includes(catId);
			a.classList.toggle('is-disabled', !ok);
		});
	}

	function updateSidebarActiveState(catId) {
		document.querySelectorAll('.baza-znan-archive__nav-group a').forEach(a => {
			const url    = new URL(a.href, location.origin);
			const linkCat = url.searchParams.get('bz_cat') || '';
			a.classList.toggle('is-active', linkCat === String(catId || ''));
		});
	}

	function runFilterSearch() {
		const search = section.querySelector('input[name="bz_search"]')?.value?.trim() || '';
		const cat    = subjectSelect?.value || '';
		const cls    = classSelect?.value   || '';
		updateSidebarActiveState(cat);
		bzUpdateUrl({ bz_search: search, bz_cat: cat, bz_class: cls });
		bzScrollTo('baza-znan-content');
		bzDoSearch({ bz_search: search, bz_cat: cat, bz_class: cls });
	}

	if (subjectSelect) applySubjectToClasses(subjectSelect.value);
	if (classSelect) {
		applyClassToSidebar(classSelect.value);
		applyClassToSubjects(classSelect.value);
	}

	showSelectorNameWhenAll(subjectSelect);
	showSelectorNameWhenAll(classSelect);

	// ── Sidebar nav AJAX intercept ────────────────────────────────────────────
	document.querySelectorAll('.baza-znan-archive__nav-group a[href]').forEach(navA => {
		const linkUrl = new URL(navA.href, location.origin);
		if (!linkUrl.searchParams.has('bz_cat')) return; // skip non-filter links (e.g. home)

		navA.addEventListener('click', e => {
			e.preventDefault();
			const catId = linkUrl.searchParams.get('bz_cat') || '';

			// Update sidebar active state
			document.querySelectorAll('.baza-znan-archive__nav-group a').forEach(l => l.classList.remove('is-active'));
			navA.classList.add('is-active');

			// Sync subject dropdown to selected category
			if (subjectSelect) {
				setCustomSelectValue(subjectSelect, catId);
				applySubjectToClasses(catId);
			}

			// Reset class dropdown
			if (classSelect) {
				setCustomSelectValue(classSelect, '');
				applyClassToSidebar('');
				applyClassToSubjects('');
			}

			const search = section.querySelector('input[name="bz_search"]')?.value?.trim() || '';
			bzUpdateUrl({ bz_search: search, bz_cat: catId, bz_class: '' });
			bzScrollTo('baza-znan-content');
			bzDoSearch({ bz_search: search, bz_cat: catId, bz_class: '' });
		});
	});

	// ── "Головна" resets all filters without reload ──────────────────────────
	const homeLink = document.querySelector('.baza-znan-archive__nav-group a[data-bz-reset]');
	if (homeLink) {
		homeLink.addEventListener('click', e => {
			e.preventDefault();

			document.querySelectorAll('.baza-znan-archive__nav-group a').forEach(l => l.classList.remove('is-active', 'is-disabled'));

			if (subjectSelect) {
				setCustomSelectValue(subjectSelect, '');
				applySubjectToClasses('');
			}
			if (classSelect) {
				setCustomSelectValue(classSelect, '');
				applyClassToSidebar('');
				applyClassToSubjects('');
			}

			const searchInput = section.querySelector('input[name="bz_search"]');
			if (searchInput) searchInput.value = '';

			bzUpdateUrl({});
			bzScrollTo('baza-znan-content');
			bzDoSearch({});
		});
	}

	// select.js не диспатчит нативный change — слушаем его кастомный selectCallback
	// bug_4: picking "Усі" is the same as no filter, so the closed select should
	// show its own name ("Предмет" / "Клас") instead of the word "Усі". That name
	// is the text of the placeholder option (value=""), which select.js otherwise
	// only shows when nothing is chosen at all.
	function showSelectorNameWhenAll(nativeSelect) {
		if (!nativeSelect || nativeSelect.value !== '0') return;

		const wrapper = nativeSelect.closest('.select');
		const label = nativeSelect.querySelector('option[value=""]')?.textContent.trim();
		if (!wrapper || !label) return;

		const titleContent = wrapper.querySelector('.select__content') || wrapper.querySelector('.select__value');
		if (titleContent) titleContent.textContent = label;
		wrapper.classList.remove('_select-active', 'has-value');
	}

	document.addEventListener('selectCallback', (e) => {
		const changed = e.detail?.select;
		if (!changed) return;

		const wrapper = changed.closest('.select');
		if (wrapper) wrapper.classList.toggle('has-value', !!changed.value);

		showSelectorNameWhenAll(changed);

		if (changed === subjectSelect) {
			applySubjectToClasses(subjectSelect.value);
			runFilterSearch();
		} else if (changed === classSelect) {
			applyClassToSidebar(classSelect.value);
			applyClassToSubjects(classSelect.value);
			runFilterSearch();
		}
	});

	// ── Mobile filter bar (≤920px) ────────────────────────────────────────────
	if (window.innerWidth <= 920) {
		const mobileBar    = document.getElementById('bz-mobile-bar');
		const heroSearch   = document.querySelector('.baza-znan-archive__hero-search');
		const mobileHeader = document.querySelector('.header-new');

		if (mobileBar && heroSearch) {
			const mobileFooter = document.querySelector('.footer') || document.querySelector('footer');

			function updateMobileBar() {
				const searchBottom = heroSearch.getBoundingClientRect().bottom;
				const headerBottom = mobileHeader ? mobileHeader.getBoundingClientRect().bottom : 0;
				const shouldShow   = searchBottom < headerBottom;

				const atFooter = mobileFooter
					? mobileFooter.getBoundingClientRect().top <= window.innerHeight - 32
					: false;

				mobileBar.classList.toggle('is-visible', shouldShow);
				mobileBar.classList.toggle('is-bar-hidden', shouldShow && atFooter);

				if (!shouldShow) {
					mobileBar.querySelectorAll('.baza-znan-archive__mobile-panel').forEach(p => p.classList.remove('is-open'));
					mobileBar.querySelectorAll('.baza-znan-archive__mobile-tab').forEach(t => t.classList.remove('is-active'));
				}
			}

			updateMobileBar();
			window.addEventListener('scroll', updateMobileBar, { passive: true });

			// Tab icon clicks — toggle corresponding panel (one at a time)
			mobileBar.querySelectorAll('.baza-znan-archive__mobile-tab').forEach(tab => {
				tab.addEventListener('click', () => {
					const panelId = 'bz-mpanel-' + tab.dataset.tab;
					const panel   = document.getElementById(panelId);
					const isOpen  = panel && panel.classList.contains('is-open');

					mobileBar.querySelectorAll('.baza-znan-archive__mobile-panel').forEach(p => p.classList.remove('is-open'));
					mobileBar.querySelectorAll('.baza-znan-archive__mobile-tab').forEach(t => t.classList.remove('is-active'));

					if (!isOpen && panel) {
						panel.classList.add('is-open');
						tab.classList.add('is-active');
						if (tab.dataset.tab === 'search') {
							panel.querySelector('.bz-mpanel-search-input')?.focus();
						}
					}
				});
			});

			// Close (X) buttons
			mobileBar.querySelectorAll('.bz-mpanel-close').forEach(btn => {
				btn.addEventListener('click', () => {
					const panelEl = document.getElementById('bz-mpanel-' + btn.dataset.panel);
					const tabEl   = mobileBar.querySelector(`.baza-znan-archive__mobile-tab[data-tab="${btn.dataset.panel}"]`);
					panelEl?.classList.remove('is-open');
					tabEl?.classList.remove('is-active');
				});
			});

			// Search panel
			const mSearchInput = mobileBar.querySelector('.bz-mpanel-search-input');
			const mSearchBtn   = mobileBar.querySelector('.bz-mpanel-search-btn');

			function doMobileSearch() {
				const searchVal = (mSearchInput?.value || '').trim();
				const desktopInput = section?.querySelector('input[name="bz_search"]');
				if (desktopInput) desktopInput.value = searchVal;

				const cat = subjectSelect?.value || '';
				const cls = classSelect?.value   || '';
				bzUpdateUrl({ bz_search: searchVal, bz_cat: cat, bz_class: cls });
				bzScrollTo('baza-znan-content');
				bzDoSearch({ bz_search: searchVal, bz_cat: cat, bz_class: cls });

				document.getElementById('bz-mpanel-search')?.classList.remove('is-open');
				mobileBar.querySelector('.baza-znan-archive__mobile-tab[data-tab="search"]')?.classList.remove('is-active');
			}

			mSearchBtn?.addEventListener('click', doMobileSearch);
			mSearchInput?.addEventListener('keydown', e => { if (e.key === 'Enter') doMobileSearch(); });

			// Скрываем кнопки классов, недоступных для выбранного предмета
			function syncMobileClassButtons(subjectId) {
				const available = subjectId && subjectClassMap[subjectId]
					? subjectClassMap[subjectId].map(String)
					: null;
				mobileBar.querySelectorAll('.bz-mpanel-class-item').forEach(b => {
					const val = b.dataset.value;
					if (!val || val === '0') return;
					const show = !available || available.includes(val);
					b.closest('li').hidden = !show;
					if (!show) b.removeAttribute('aria-selected');
				});
			}

			// Скрываем кнопки предметов, недоступных для выбранного класса
			function syncMobileSubjectButtons(classId) {
				const available = classId && classSubjectMap[classId]
					? classSubjectMap[classId].map(String)
					: null;
				mobileBar.querySelectorAll('.bz-mpanel-subject-item').forEach(b => {
					const val = b.dataset.value;
					if (!val || val === '0') return;
					const show = !available || available.includes(val);
					b.closest('li').hidden = !show;
					if (!show) b.removeAttribute('aria-selected');
				});
			}

			// Начальная синхронизация при загрузке страницы с URL-параметрами
			syncMobileClassButtons(subjectSelect?.value || '');
			syncMobileSubjectButtons(classSelect?.value || '');

			// Subject items
			mobileBar.querySelectorAll('.bz-mpanel-subject-item').forEach(btn => {
				btn.addEventListener('click', () => {
					const value  = btn.dataset.value;
					const isAll  = value === '0';
					const newVal = isAll ? '' : value;

					mobileBar.querySelectorAll('.bz-mpanel-subject-item').forEach(b => b.removeAttribute('aria-selected'));
					if (newVal) btn.setAttribute('aria-selected', 'true');

					if (subjectSelect) {
						subjectSelect.value = newVal;
						applySubjectToClasses(newVal);
					}

					if (isAll) {
						// Сбросить класс и показать все кнопки в обеих панелях
						mobileBar.querySelectorAll('.bz-mpanel-class-item').forEach(b => b.removeAttribute('aria-selected'));
						if (classSelect) { classSelect.value = ''; applyClassToSubjects(''); applyClassToSidebar(''); }
						syncMobileClassButtons('');
						syncMobileSubjectButtons('');
					} else {
						syncMobileClassButtons(newVal);
					}

					const search = (mSearchInput?.value || section?.querySelector('input[name="bz_search"]')?.value || '').trim();
					const cls    = classSelect?.value || '';
					updateSidebarActiveState(newVal);
					bzUpdateUrl({ bz_search: search, bz_cat: newVal, bz_class: cls });
					bzScrollTo('baza-znan-content');
					bzDoSearch({ bz_search: search, bz_cat: newVal, bz_class: cls });

					document.getElementById('bz-mpanel-subject')?.classList.remove('is-open');
					mobileBar.querySelector('.baza-znan-archive__mobile-tab[data-tab="subject"]')?.classList.remove('is-active');
				});
			});

			// Class items
			mobileBar.querySelectorAll('.bz-mpanel-class-item').forEach(btn => {
				btn.addEventListener('click', () => {
					const value  = btn.dataset.value;
					const isAll  = value === '0';
					const newVal = isAll ? '' : value;

					mobileBar.querySelectorAll('.bz-mpanel-class-item').forEach(b => b.removeAttribute('aria-selected'));
					if (newVal) btn.setAttribute('aria-selected', 'true');

					if (classSelect) {
						classSelect.value = newVal;
						applyClassToSubjects(newVal);
						applyClassToSidebar(newVal);
					}

					if (isAll) {
						// Сбросить предмет и показать все кнопки в обеих панелях
						mobileBar.querySelectorAll('.bz-mpanel-subject-item').forEach(b => b.removeAttribute('aria-selected'));
						if (subjectSelect) { subjectSelect.value = ''; applySubjectToClasses(''); }
						syncMobileSubjectButtons('');
						syncMobileClassButtons('');
					} else {
						syncMobileSubjectButtons(newVal);
					}

					const search = (mSearchInput?.value || section?.querySelector('input[name="bz_search"]')?.value || '').trim();
					const cat    = subjectSelect?.value || '';
					updateSidebarActiveState(cat);
					bzUpdateUrl({ bz_search: search, bz_cat: cat, bz_class: newVal });
					bzScrollTo('baza-znan-content');
					bzDoSearch({ bz_search: search, bz_cat: cat, bz_class: newVal });

					document.getElementById('bz-mpanel-class')?.classList.remove('is-open');
					mobileBar.querySelector('.baza-znan-archive__mobile-tab[data-tab="class"]')?.classList.remove('is-active');
				});
			});
		}
	}
});
